import React from 'react';

import { ProductCard } from 'features/product-card/components/product-card/product-card';
import {
  ProductCardMobileReviewsFormContainer,
  ProductCardStickyReviewsFormContainer,
} from 'features/product-card/components/product-card/page-containers';
import {
  productCardInfoWrapperReviewsFormClass,
  ProductImageReviewsFormContainer,
} from 'features/product-card/components/product-card/styles';
import { ProductUIElementsVisibility } from 'features/product-card/components/product-card/types';
import {
  mainPriceReviewsFormClass,
  primaryPriceFractCurrencyReviewsFormClass,
} from 'features/product-card/components/product-special-price/common-styles';
import { useBreakpoints } from 'common/hooks';

const desktopElementsVisibility = ProductUIElementsVisibility.All;

const mobileElementsVisibility = ProductUIElementsVisibility.Reviews;

export const ProductCardWrapper = () => {
  const { mobile, tablet } = useBreakpoints() || {
    mobile: false,
    tablet: false,
  };

  const isMobileView = mobile || tablet;

  if (isMobileView) {
    return (
      <ProductCard
        elementsVisibility={mobileElementsVisibility}
        Container={ProductCardMobileReviewsFormContainer}
        ImageContainer={ProductImageReviewsFormContainer}
        mainPriceClassName={mainPriceReviewsFormClass}
        fractPriceClassName={primaryPriceFractCurrencyReviewsFormClass}
        infoWrapperClassName={productCardInfoWrapperReviewsFormClass}
      />
    );
  }

  return (
    <ProductCard
      elementsVisibility={desktopElementsVisibility}
      Container={ProductCardStickyReviewsFormContainer}
      ImageContainer={ProductImageReviewsFormContainer}
      mainPriceClassName={mainPriceReviewsFormClass}
      fractPriceClassName={primaryPriceFractCurrencyReviewsFormClass}
    />
  );
};
